let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2a8Ft")).then(() => parcelRequire('gzwHi'));